goog.provide("shadow.js.shim.module$src$svg$inform$error_triangle_fill_svg$default");
shadow.js.shim.module$src$svg$inform$error_triangle_fill_svg$default = shadow.js.shim.module$src$svg$inform$error_triangle_fill_svg.default;
